import * as zod from 'zod';

import { CartesianPose } from '@sb/geometry';
import { CollisionBoxConfig } from '@sb/integrations/types/CollisionBox';

import {
  DefaultTooltipTransform,
  DH_DEFAULT_COLLISION_BOX,
} from '../constants';

export const DHConfiguration = zod.object({
  family: zod.literal('DHBase'),
  name: zod.string().default('DH Gripper'),
  tcpTransform: CartesianPose.default(DefaultTooltipTransform),
  minGripWidth: zod.number().default(0),
  maxGripWidth: zod.number().default(145 / 1_000.0),
  collisionBox: CollisionBoxConfig.default(DH_DEFAULT_COLLISION_BOX),
});

export type DHConfiguration = zod.infer<typeof DHConfiguration>;
